import { z } from 'zod';
/** One row per (day, model, purpose) — for charting cost over time. */
export const LlmUsageDailyRow = z.object({
    day: z.string(), // YYYY-MM-DD
    model: z.string(),
    purpose: z.string(),
    calls: z.number().int(),
    inputTokens: z.number().int(),
    outputTokens: z.number().int(),
    costUsd: z.number(),
});
export const LlmUsageResponse = z.object({
    days: z.number().int(), // how many days of history returned
    rows: z.array(LlmUsageDailyRow),
    totals: z.object({
        calls: z.number().int(),
        totalTokens: z.number().int(),
        costUsd: z.number(),
    }),
});
//# sourceMappingURL=llm-usage.js.map